/* eslint-disable camelcase */
import { HttpRequest } from '../stores/types/types';
import { Entity } from '../types/interfaces';
import { buildSyncUrl, getAuthenticatedRequestInit, getSyncHeaders } from './utils';
import { getApiHost } from '../utils/hosts';

export const GetTokboxToken = (
	session: string,
	data?: { [key: string]: any },
) => fetch(`${getApiHost()}/get-tokbox-token`, {
	method: 'POST',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
	body: JSON.stringify({
		sessionId: session,
		data,
	}),
}).then((res) => {
	if (res.ok) return res.json();
	return res.status;
}).catch((e) => e);

export const GetSession = () => fetch(`${getApiHost()}/v2/opentok/session`, {
	method: 'GET',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
}).then((res) => {
	if (res.ok) {
		return res.json();
	}
	return res.status;
}).catch((e) => e);

export const SetStreamInfo = (
	token: string,
	stream_id: string,
	archive_id: string,
	session: string,
	gr_user: number | undefined,
	meeting: number,
	device_type: string | null,
	name: string | undefined,
) => fetch(`${getApiHost()}/v2/opentok/stream`, {
	method: 'POST',
	body: JSON.stringify({
		stream_id,
		archive_id,
		session,
		gr_user,
		meeting,
		device_type,
		name,
	}),
	...getAuthenticatedRequestInit(token),
// Resolves whether the row was written. The endpoint replies with sendStatus, so there is
// no JSON body to read — callers only need to know if it landed, and a false lets them retry.
}).then((res) => res.ok).catch(() => false);

export const GetOpentokSessionEntity = async (
	token: string,
	roomId: number,
): Promise<Entity | null> => {
	try {
		const url = buildSyncUrl(`opentok/${roomId}`);
		const res = await fetch(url, {
			method: HttpRequest.Get,
			headers: getSyncHeaders(token),
		});
		if (res.status === 200) {
			const entity = await res.json();
			return entity;
		} else {
			return null;
		}
	} catch (error) {
		console.error(error);
		return null;
	}
};
